import { message } from 'antd'
import { formatNumber } from 'meinian-package/src/utils/number'
// eslint-disable-next-line import/no-named-as-default
import { ossImg, picProcess } from 'meinian-package/src/utils/image'
import Uninterested from '../cardUninterestedAction'
import HoverImage from '../hoverImage'
import styles from './index.module.less'

const KeyNum = ({ name, value, hideZero }) =>
  hideZero && value == 0 ? null : (
    <span className="key-num">
      {name}
      <i>{value}</i>
    </span>
  )

export default ({ data, style, innerWidth, onUninterested }) => {
  // 博主
  const { status, includedStatus, bloggerId } = data
  const jumpToDetail = () => {
    if (status == 0) {
      message.info('该博主已被下架，如有疑问请联系售后', 3)
      return
    }
    if (status == 3) {
      message.info('抱歉～无法访问主页，博主正在收录中或无公开博文', 3)
      return
    }
    if (includedStatus === 3) {
      message.info('博主收录失败，请联系客服', 3)
      return
    }
    if (includedStatus === 1) {
      message.info('博主收录中，暂不支持查看', 3)
      return
    }
    window.open(`/df/detail/blogger?id=${bloggerId}&sourceType=${data.sourceType}`)
  }
  return (
    <div className={styles['intellect-card-blogger']} style={style}>
      <div className="intellect-card-blogger-header">
        <Uninterested
          itemId={data.itemId}
          className="intellect-card-blogger-uninterested"
          onChange={() => {
            onUninterested(data)
          }}
        />
        <div className="intellect-card-blogger-header-left">
          {data.headImg ? (
            <img onClick={jumpToDetail} className="intellect-card-blogger-logo" src={picProcess(data.headImg)} />
          ) : (
            <div
              onClick={jumpToDetail}
              className="no-blogger-logo"
              style={{ border: 'solid 1px #f7f7fa', display: 'inline-block' }}
            >
              {data.nickName[0]}
            </div>
          )}
        </div>
        <div className="intellect-card-blogger-header-right">
          <div className="blogger-name" onClick={jumpToDetail} style={{ width: 'calc(100% - 40px)' }}>
            <div className="name text-overflow">
              {data.nickName || data.nickname}
              {/* ins大写 下红书小写 后端改说麻烦 我这边适配 。。。。。。。。。。。。。。。。。。 */}
            </div>
          </div>
          <div className="blogger-tag" onClick={jumpToDetail}>
            {data.sumTags ? (
              data.sumTags.split('#').map((k) => k && <div className="tag">{k}</div>)
            ) : (
              <div className="tag">暂无标签</div>
            )}
          </div>
          <div className="blogger-key-num" onClick={jumpToDetail}>
            {/* 帖子 ins 小红书字段不一样 后端历史问题 导致适配 */}
            <KeyNum name="帖子" value={formatNumber(data.blogNum || data.noteNum)} />
            <div className="key-line" />
            <KeyNum name="粉丝" value={formatNumber(data.fansNum, 1)} />
          </div>
        </div>
      </div>
      <ListItemImg data={data.lastBlogList?.slice(0, 4)} jumpToDetail={jumpToDetail} innerWidth={innerWidth} />
    </div>
  )
}

const ListItemImg = ({ data, jumpToDetail, innerWidth }) => {
  const count = 4
  const imgWidth = innerWidth / count - 14
  return (
    <div className="images">
      {data?.map((img, i) => {
        if (i === data.length - 1) {
          return (
            <a
              key={img.mainUrl}
              className="dimback"
              style={{ width: imgWidth, height: imgWidth }}
              onClick={(e) => {
                e.stopPropagation()
                jumpToDetail()
              }}
            >
              <img src={ossImg(img.mainUrl, 600, 600)} className="dim" />
              <div className="blogger-text">查看更多</div>
            </a>
          )
        }
        return (
          <a
            key={img.mainUrl}
            onClick={(e) => {
              e.stopPropagation()
              window.open(
                `/df/detail/image?blogIds=${img.imageGroupEntityId}&unionIds=${img.unionId}&imageGroupIndex=${img.imageGroupIndex}&platformId=${img.platformId}`
              )
            }}
          >
            <HoverImage url={img.mainUrl} placement="bottom" wrapStyle={{ width: imgWidth, height: imgWidth }} />
          </a>
        )
      })}
    </div>
  )
}
